import { StringUtil } from "@eres/core";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import Strings from "@my-dld/assets/strings";

export function convertErrorToMessage( message: any, Strings: { [ k: string ]: string } ) {
	const m = message;
	const t = typeof ( message as any );
	switch ( t ) {
		case "undefined":
			return;
		case "object":
			const x = message as any;
			if ( x.errorMessage ) {
				message = x.errorMessage;
			} else if ( x.ErrorMessage ) {
				message = x.ErrorMessage;
			} else if ( x.message ) {
				message = x.message;
			} else if ( x.Message ) {
				message = x.Message;
			} else if ( x.MessageId ) {
				message = Strings[ x.MessageId ];
			} else if ( x.messageId ) {
				message = Strings[ x.messageId ];
			} else {
				const lv = getLocalValue( message );
				if ( lv ) message = lv.toString();
				else message = x.toString();
			}
			break;
		case "boolean":
			message = message.toString();
			break;
		case "number":
			message = message.toString();
			break;
		case "string":
			if ( !StringUtil.isEmptyStringOrNull( message ) ) {
				const k = message.toString().trim().toLowerCase();
				const ms = Strings[ k ];
				if ( !StringUtil.isEmptyStringOrNull( ms ) ) {
					return ms;
				}
			}
			break;
		case "function":
			return;
		case "symbol":
			message = message.toString();
			break;
		case "bigint":
			message = message.toString();
			break;
		default:
			message = message.toString();
	}
	let mx = message ?? m.toString();
	return mx.trim();
}

export function convertError( message: any, ) {
	return convertErrorToMessage( message, Strings );
}

export function useAsError( message: any ): string | undefined {
	return convertErrorToMessage( message, Strings );
}
